import { render } from "./CreateNewProject.vue?vue&type=template&id=609d40a0&ts=true"
import script from "./CreateNewProject.vue?vue&type=script&lang=ts"
export * from "./CreateNewProject.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__